import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Sparkles } from 'lucide-react';
import { formatPetDate } from '@/utils/formatDate';
import { thumbStyle } from '@/lib/utils';

const PetCard = ({ pet, onClick }) => (
  <Card
    className="cursor-pointer rounded-3xl overflow-hidden hover:shadow-lg transition-shadow"
    onClick={onClick}
  >
    <div className="h-48 bg-muted overflow-hidden">
      {pet.photos?.[0] ? (
        <img
          src={pet.photos[0]}
          alt={pet.name || 'Mascota'}
          className="w-full h-full object-cover"
          style={thumbStyle(pet.thumbnail_position, pet.thumbnail_zoom)}
          loading="lazy"
        />
      ) : (
        <div className="w-full h-full flex items-center justify-center text-4xl">🐾</div>
      )}
    </div>
    <CardHeader className="pb-2">
      <div className="flex justify-between items-start">
        <CardTitle className="text-lg">{pet.name || 'Sin nombre'}</CardTitle>
        <Badge variant={pet.type === 'lost' ? 'destructive' : 'default'} className="rounded-full">
          {pet.type === 'lost' ? 'Perdida' : 'Encontrada'}
        </Badge>
      </div>
    </CardHeader>
    <CardContent className="pt-0">
      <p className="text-sm text-muted-foreground">
        {pet.pet_type === 'dog' ? '🐕 Perro' : '🐈 Gato'}
      </p>
      <p className="text-sm text-muted-foreground">📍 {pet.location?.slice(0, 30)}</p>
      <p className="text-xs text-muted-foreground mt-1">
        {formatPetDate(pet.date_lost_found)}
      </p>
      {pet.match_count > 0 && (
        <Badge variant="secondary" className="rounded-full mt-2">
          <Sparkles className="h-3 w-3 mr-1" />
          {pet.match_count} coincidencia(s)
        </Badge>
      )}
    </CardContent>
  </Card>
);

export default PetCard;
